import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { TableModule, Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { TabViewModule } from 'primeng/tabview';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { RichiesteService } from '../../services/richieste.service';
import { Richiesta } from '../../models/richiesta.model';
import { StiliService } from '../../services/stili.service';
import { UserService } from '../../services/user.service';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { MenuModule } from 'primeng/menu';
import { Menu } from 'primeng/menu';
import { ChartModule } from 'primeng/chart';
import { StoricoComponent } from './storico/storico.component';
import { StoricoContributiComponent } from './storico-contributi/storico-contributi.component';
import { ComunicaContributoComponent } from './comunica-contributo/comunica-contributo.component';
import { CaricaLetteraComponent } from './carica-lettera/carica-lettera.component';
import { GeneraRichiesteComponent } from './genera-richieste/genera-richieste.component';
import { ConfermaEliminazioneComponent } from './conferma-eliminazione/conferma-eliminazione.component';
import { ChiudiPreparazioneRichiestaComponent } from './chiudi-preparazione/chiudi-preparazione-richiesta.component';
import { ModificaRichiestaComponent } from './modifica-richiesta/modifica-richiesta.component';
import { ConfermaFinanziamentoComponent } from './conferma-finanziamento/conferma-finanziamento.component';
import localeIt from '@angular/common/locales/it';
import { FirebaseStorageService } from '../../services/firebase-storage.service';
import { saveAs } from 'file-saver';
import { AnimationOptions, LottieComponent } from 'ngx-lottie';
import player from 'lottie-web';
import { ExcelService } from '../../services/excelService.service';
import { VarianteComponent } from './variante/variante.component';
import { FiltriStatoService } from '../../services/filtri-stato.service';
import { AssegnaMassivamenteDetermineComponent } from '../interventi/assegna-massivamente-determine/assegna-massivamente-determine.component';
import { EntiEsecutoriService } from '../../services/entiEsecutori.service';
import { EnteEsecutore } from '../../models/ente.model';
import { InterventiService } from '../../services/interventi.service';

export function playerFactory() {
  return player;
}
// Registro il locale italiano
registerLocaleData(localeIt, 'it-IT');

@Component({
  selector: 'app-richieste',
  templateUrl: './richieste.component.html',
  styleUrls: ['./richieste.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    TagModule,
    TooltipModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    TabViewModule,
    TieredMenuModule,
    MenuModule,
    ChartModule,
    StoricoComponent,
    StoricoContributiComponent,
    ComunicaContributoComponent,
    CaricaLetteraComponent,
    GeneraRichiesteComponent,
    ConfermaEliminazioneComponent,
    ChiudiPreparazioneRichiestaComponent,
    ModificaRichiestaComponent,
    ConfermaFinanziamentoComponent,
    VarianteComponent,
    LottieComponent,
    AssegnaMassivamenteDetermineComponent,
  ],
  providers: [MessageService],
})
export class RichiesteComponent implements OnInit {
  @ViewChild(ChiudiPreparazioneRichiestaComponent)
  chiudiPreparazioneRichiestaComponent!: ChiudiPreparazioneRichiestaComponent;
  @ViewChild(ModificaRichiestaComponent)
  modificaRichiestaComponent!: ModificaRichiestaComponent;
  @ViewChild(StoricoComponent) storicoRichiestaComponent!: StoricoComponent;
  @ViewChild(StoricoContributiComponent)
  storicoContributiComponent!: StoricoContributiComponent;
  @ViewChild(ConfermaFinanziamentoComponent)
  confermaFinanziamentoComponent!: ConfermaFinanziamentoComponent;
  @ViewChild(VarianteComponent) varianteComponent!: VarianteComponent;

  annoCorrente: number = new Date().getFullYear();
  readonly annoAttualeReale: number = new Date().getFullYear(); // Anno corrente immutabile
  statoFiltro: string | null = null;
  enteFiltro: string | null = null;
  selectedRichiesta: Richiesta | null = null;
  // Flag per tracciare se i filtri sono attivi
  filtriAttivi: boolean = false;
  richiesteAnnoSuccessivoSonoPresenti: boolean = true;
  firstLoad: boolean = true;
  private annoPrecedente: number | null = null; // Traccia l'anno precedente per capire se è stato rimosso
  private rimozioneFiltroAnno: boolean = false; // Flag per indicare che stiamo rimuovendo il filtro anno
  private cambioFiltroAnnoInCorso: boolean = false; // Flag per indicare che stiamo cambiando il filtro anno (per evitare doppie chiamate)
  isEnteEsecutore: boolean = false;
  isAdminOrUmvs: boolean = false;
  enteId: string | null = null;
  titoloRichieste: string = '';
  public titoloStorico: string = '';

  // Dati per il grafico storico
  storicoRichieste: Richiesta[] = [];
  storicoCaricato: boolean = false;
  chartData: any;
  chartOptions: any;

  // Filtro ente per lo storico
  entiEsecutori: EnteEsecutore[] = [];
  enteStoricoSelezionato: EnteEsecutore | null = null; // null = tutti gli enti
  enteStoricoSelezionatoPerDropdown: EnteEsecutore | null = null; // Versione per il dropdown (usa TUTTI_GLI_ENTI invece di null)

  // Indice della tab attiva (0 = Richieste, 1 = Storico)
  tabAttivaIndex: number = 0;

  // Oggetto speciale per rappresentare "Tutti gli enti"
  readonly TUTTI_GLI_ENTI: EnteEsecutore = {
    id: -1,
    label: 'Tutti gli enti',
    categoria: { id: -1, codice: '', descrizione: 'Tutti gli enti' },
    comuni: [],
    bacini: [],
    statoRichiesta: null,
  } as EnteEsecutore;

  /**
   * Getter per l'array degli enti con l'opzione "Tutti gli enti" come prima opzione
   */
  get entiEsecutoriConTutti(): EnteEsecutore[] {
    return [this.TUTTI_GLI_ENTI, ...this.entiEsecutori];
  }
  // Dialogo filtri
  mostraFiltri: boolean = false;

  // Dialogo storico
  mostraStorico: boolean = false;
  richiestaIdStorico: number = 0;

  // Dialogo comunica contributo
  mostraComunicaContributo: boolean = false;
  richiestaSelezionata: Richiesta | null = null;

  mostraAssegnaMassivamenteDetermine: boolean = false;

  // Modali per i report regione
  mostraReportAnnuale: boolean = false;
  mostraReportMensile: boolean = false;
  annoReportSelezionato: number = new Date().getFullYear();
  meseReportSelezionato: number = new Date().getMonth() + 1; // 1-12
  mesiDisponibili: any[] = [
    { label: 'Gennaio', value: 1 },
    { label: 'Febbraio', value: 2 },
    { label: 'Marzo', value: 3 },
    { label: 'Aprile', value: 4 },
    { label: 'Maggio', value: 5 },
    { label: 'Giugno', value: 6 },
    { label: 'Luglio', value: 7 },
    { label: 'Agosto', value: 8 },
    { label: 'Settembre', value: 9 },
    { label: 'Ottobre', value: 10 },
    { label: 'Novembre', value: 11 },
    { label: 'Dicembre', value: 12 },
  ];

  // Dialogo carica lettera
  mostraCaricaLettera: boolean = false;

  // Dialogo genera richieste
  mostraGeneraRichieste: boolean = false;

  // Dialogo conferma eliminazione
  mostraConfermaEliminazione: boolean = false;

  // Dialogo dichiarazione pronta
  mostraDichiarazionePronta: boolean = false;

  // Dialogo creazione variante
  mostraVariante: boolean = false;

  isDownloading: boolean = false;
  options: AnimationOptions = {
    path: '/assets/animations/spinner-downloading.json',
    loop: true,
    autoplay: true,
  };
  // Parametri filtri
  filtri = {
    anno: new Date().getFullYear() as number | null,
    stato: null as string | null,
    enteEsecutore: null as string | null,
  };

  // Opzioni per i filtri
  anniDisponibili: number[] = [];
  anniDisponibiliConRimuovi: any[] = []; // Lista degli anni con opzione "Rimuovi filtro"
  statiConRimuovi: any[] = []; // Lista degli stati con opzione "Rimuovi filtro"

  // Array di esempio per le richieste (da sostituire con dati reali dal servizio)
  richieste: Richiesta[] = [];
  richiesteOriginali: Richiesta[] = []; // Copia dei dati originali caricati dalle API
  richiesteCaricate: boolean = false;

  @ViewChild('menuAzioniTiered', { static: true }) azioniMenuTiered!: Menu;
  @ViewChild('menuReport') menuReport!: Menu;
  @ViewChild('dt') dt!: Table;

  // Proprietà per il filtro globale della tabella
  filtroTestoGlobale: string = '';

  public menuAzioniItems!: MenuItem[];
  public menuReportItems!: MenuItem[];

  // Stati disponibili per il filtro
  //TODO: da sistemare con i dati reali / SPOSTARE
  stati: any[] = [
    { label: 'In preparazione', value: 'in preparazione' },
    { label: 'Presentate', value: 'presentata' },
    { label: 'Da finanziare', value: 'da finanziare' },
    { label: 'Finanziate', value: 'finanziata' },
    { label: 'In rendicontazione', value: 'in rendicontazione' },
    { label: 'Rendicontate', value: 'rendicontata' },
    { label: 'In liquidazione', value: 'in liquidazione' },
    { label: 'Liquidate', value: 'liquidata' },
  ];

  // Colonne da visualizzare nella tabella
  //TODO: da SPOSTARE in servizio di utilità
  cols: any[] = [
    { field: 'anno', header: 'Anno', sortable: true, width: '5%' },
    { field: 'tipoEnte', header: 'Tipo Ente', sortable: false, width: '4%' },
    { field: 'comune', header: 'Ente', sortable: false, width: '15%' },
    { field: 'stato', header: 'Stato', sortable: false, width: '5%' },
    {
      field: 'importoRichiesto',
      header: 'Richiesto',
      sortable: true,
      width: '5%',
    },
    {
      field: 'importoContributo',
      header: 'Contributo',
      sortable: true,
      width: '5%',
    },
    {
      field: 'importoRimodulato',
      header: 'Rimodulato',
      sortable: true,
      width: '5%',
    },
    {
      field: 'importoFinanziato',
      header: 'Finanziato',
      sortable: true,
      width: '5%',
    },
    {
      field: 'importoRendicontato',
      header: 'Rendicontato',
      sortable: true,
      width: '5%',
    },
    {
      field: 'importoLiquidato',
      header: 'Liquidato',
      sortable: true,
      width: '5%',
    },
    { field: 'presentata', header: 'Presentata', sortable: true, width: '8%' },
    { field: 'finanziata', header: 'Finanziata', sortable: true, width: '8%' },
  ];

  // Dialogo modifica richiesta
  mostraModificaRichiesta: boolean = false;

  // Dialogo conferma finanziamento
  mostraConfermaFinanziamento: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private logger: NGXLogger,
    private messageService: MessageService,
    private richiesteService: RichiesteService,
    private userService: UserService,
    public stiliService: StiliService,
    private firebaseStorageService: FirebaseStorageService,
    private excelService: ExcelService,
    private filtriStatoService: FiltriStatoService,
    private cdr: ChangeDetectorRef,
    private entiEsecutoriService: EntiEsecutoriService,
    private interventiService: InterventiService,
  ) {
    // Genero array con anni dal più recente al più vecchio (2025, 2024, 2023, ...)
    const annoAttuale = new Date().getFullYear();
    this.anniDisponibili = [];

    // Aggiungi anno successivo
    this.anniDisponibili.push(annoAttuale + 1);

    // Aggiungi anno corrente e precedenti (5 anni)
    for (let i = 0; i < 6; i++) {
      this.anniDisponibili.push(annoAttuale - i);
    }

    console.log('[RICHIESTE] Anni disponibili ordinati:', this.anniDisponibili);

    // Popola l'array con opzione "Rimuovi filtro"
    this.anniDisponibiliConRimuovi = [
      ...this.anniDisponibili,
      {
        anno: 'Tutti gli anni',
        id: 'remove-filter',
        isRemoveOption: true,
      } as any,
    ];

    // Popola l'array degli stati con opzione "Rimuovi filtro"
    this.statiConRimuovi = [
      ...this.stati,
      {
        label: 'Tutti gli stati',
        value: 'remove-filter',
        id: 'remove-filter',
        isRemoveOption: true,
      } as any,
    ];
  }

  ngOnInit() {
    // Verifica se l'utente è un ENTE_ESECUTORE
    const ruoloUtente = localStorage.getItem('ruolo');
    //this.logger.info(`[RICHIESTE] Ruolo utente: ${ruoloUtente}`);
    this.isEnteEsecutore = ruoloUtente === 'ENTE_ESECUTORE';
    this.isAdminOrUmvs =
      ruoloUtente === 'UMVS' ||
      ruoloUtente === 'ADMIN' ||
      ruoloUtente === 'SUPERADMIN';

    // Inizializza il menu dei report
    this.initMenuReport();

    // Ottieni l'ID dell'ente se l'utente è un ENTE_ESECUTORE
    if (this.isEnteEsecutore) {
      // Per ENTE_ESECUTORE non mostriamo mai il pulsante "Genera", quindi impostiamo sempre a true
      this.richiesteAnnoSuccessivoSonoPresenti = true;
      this.enteId = localStorage.getItem('enteId') || '';
      this.titoloRichieste =
        'RICHIESTE DEL ' + localStorage.getItem('enteLabel')?.toUpperCase();

      // Carica lo storico per il grafico
      this.caricaStoricoRichieste();

      // Forza i parametri corretti per l'utente ENTE_ESECUTORE
      //this.filtriAttivi = true;

      // SOLUZIONE AGGRESSIVA: forzare immediatamente il caricamento dei dati filtrati
      if (!this.route.snapshot.queryParams['ente']) {
        // Usa caricaRichieste invece di chiamare direttamente il servizio
        // così il filtro di testo globale viene riapplicato correttamente
        this.caricaRichieste(null, this.annoCorrente, this.enteId);

        // Aggiorna l'URL per coerenza
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { ente: this.enteId },
          replaceUrl: true, // Sostituisce l'URL corrente senza aggiungere una nuova entry nella history
        });

        return; // Interrompe il flusso normale, evitando la sottoscrizione standard ai queryParams
      }
    } else {
      this.titoloRichieste = 'RICHIESTE';

      // Carica lo storico per il grafico anche per UMVS/ADMIN/SUPERADMIN
      if (this.isAdminOrUmvs) {
        this.caricaEntiEsecutori();
        // Inizializza con "Tutti gli enti" selezionato
        this.enteStoricoSelezionato = null;
        this.enteStoricoSelezionatoPerDropdown = this.TUTTI_GLI_ENTI;
        this.caricaStoricoRichieste();
      }
    }

    // Sottoscrizione ai parametri della rotta per leggere i filtri
    this.route.queryParams.subscribe((params) => {
      console.log('[RICHIESTE] queryParams ricevuti:', params);

      // Verifica se ci sono filtri salvati da ripristinare SOLO alla prima esecuzione senza query params
      const filtriSalvati = this.filtriStatoService.getFiltriRichieste();
      const hasExistingFilters = Object.keys(params).length > 0;

      console.log(
        '[RICHIESTE] Filtri salvati:',
        filtriSalvati,
        'hasExistingFilters:',
        hasExistingFilters,
      );

      if (filtriSalvati && !hasExistingFilters) {
        // Costruisci i query parameters per il ripristino
        const queryParams: any = {};

        // Ripristina sempre anno e stato se presenti
        if (filtriSalvati.anno) queryParams.anno = filtriSalvati.anno;
        if (filtriSalvati.stato) queryParams.stato = filtriSalvati.stato;

        // Per gli enti:
        // - ENTE_ESECUTORE: usa sempre il proprio enteId
        // - UMVS/ADMIN: ripristina solo se era effettivamente impostato un filtro ente
        if (this.isEnteEsecutore) {
          queryParams.ente = this.enteId;
        } else if (filtriSalvati.ente) {
          queryParams.ente = filtriSalvati.ente;
        }

        // Pulisce i filtri salvati prima del ripristino
        this.filtriStatoService.pulisciFiltriRichieste();

        // Ripristina i filtri salvati navigando con i query parameters
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: queryParams,
          replaceUrl: true,
        });

        return; // Esci da questa esecuzione, la prossima avrà i query params corretti
      }
      this.statoFiltro = params['stato'] || null;
      // Se 'anno' è presente nei query params, usalo, altrimenti usa null per caricare tutti gli anni
      // Usa l'anno precedente per capire se è stato rimosso
      let annoFiltro: number | null = null;
      if (
        params['anno'] !== undefined &&
        params['anno'] !== null &&
        params['anno'] !== ''
      ) {
        // Se 'anno' è presente e non è null/vuoto, convertilo in numero
        annoFiltro = Number(params['anno']);
        this.annoPrecedente = annoFiltro; // Salva l'anno corrente
      } else if (this.firstLoad && params['anno'] === undefined) {
        // Solo al primo caricamento, se non c'è anno nei params, usa annoCorrente come default
        annoFiltro = this.annoCorrente;
        this.annoPrecedente = annoFiltro;
        this.firstLoad = false; // Segna che il primo caricamento è stato fatto
      } else {
        // Se non è il primo caricamento e anno non è presente o è null/vuoto
        // Se il flag rimozioneFiltroAnno è true, significa che stiamo rimuovendo il filtro
        if (this.rimozioneFiltroAnno) {
          // L'anno è stato rimosso esplicitamente, usa null per caricare tutte le richieste
          annoFiltro = null;
          this.annoPrecedente = null; // Reset dell'anno precedente
          this.rimozioneFiltroAnno = false; // Reset del flag
        } else if (this.filtri.anno === null) {
          // L'anno è stato rimosso esplicitamente, usa null per caricare tutte le richieste
          annoFiltro = null;
          this.annoPrecedente = null; // Reset dell'anno precedente
        } else if (this.annoPrecedente !== null) {
          // L'anno è stato rimosso, usa null per caricare tutte le richieste
          annoFiltro = null;
          this.annoPrecedente = null; // Reset dell'anno precedente
        } else {
          // Nessun anno era presente prima, mantieni null
          annoFiltro = null;
        }
      }

      if (annoFiltro) {
        this.annoCorrente = Number(annoFiltro); // Converti sempre in numero
      } else {
        // Se non c'è filtro anno, non impostare annoCorrente così il titolo non mostra l'anno
        this.annoCorrente = this.annoAttualeReale; // Mantieni un valore di default ma non viene mostrato nel titolo
      }
      // IMPORTANTE: Verifica aggiuntiva per utenti ENTE_ESECUTORE
      const enteFiltro = this.isEnteEsecutore
        ? this.enteId // Usa SEMPRE enteId per ENTE_ESECUTORE
        : params['ente'] || null;

      // Doppio controllo per ENTE_ESECUTORE
      if (this.isEnteEsecutore && enteFiltro !== this.enteId) {
        this.logger.warn(
          `[RICHIESTE] Correzione enteFiltro: ${enteFiltro} -> ${this.enteId}`,
        );
      }

      // Aggiorno il modello dei filtri con i valori dell'URL
      // Se non ci sono query params, usa i valori di default già inizializzati
      this.filtri.stato = this.statoFiltro;
      // Se c'è un annoFiltro nei query params, usalo, altrimenti usa null per mostrare tutti gli anni
      this.filtri.anno = annoFiltro;
      this.filtri.enteEsecutore = this.isEnteEsecutore
        ? this.enteId
        : enteFiltro;

      // Forza il change detection per aggiornare il titolo quando cambia filtri.anno
      this.cdr.detectChanges();

      // Verifico se ci sono filtri attivi
      this.filtriAttivi = this.verificaFiltriAttivi();

      console.log(
        `[RICHIESTE] Caricamento richieste con filtri: stato=${this.statoFiltro}, anno=${annoFiltro || 'tutti'}, ente=${enteFiltro}, isEnteEsecutore=${this.isEnteEsecutore}, rimozioneFiltroAnno=${this.rimozioneFiltroAnno}, cambioFiltroAnnoInCorso=${this.cambioFiltroAnnoInCorso}`,
      );

      // Se il flag rimozioneFiltroAnno è true, significa che caricaRichieste() è già stato chiamato
      // in onAnnoChange(), quindi non chiamarlo di nuovo qui per evitare doppie chiamate
      if (this.rimozioneFiltroAnno) {
        console.log(
          '[RICHIESTE] Rimozione filtro anno in corso, caricaRichieste() già chiamato in onAnnoChange()',
        );
        this.rimozioneFiltroAnno = false; // Reset del flag
        return; // Esci senza chiamare caricaRichieste() di nuovo
      }

      // Se il flag cambioFiltroAnnoInCorso è true, significa che caricaRichieste() è già stato chiamato
      // in onAnnoChange(), quindi non chiamarlo di nuovo qui per evitare doppie chiamate
      if (this.cambioFiltroAnnoInCorso) {
        console.log(
          '[RICHIESTE] Cambio filtro anno in corso, caricaRichieste() già chiamato in onAnnoChange()',
        );
        return; // Esci senza chiamare caricaRichieste() di nuovo (il flag viene resettato dopo un delay)
      }

      // Carica le richieste in base ai filtri
      // Se annoFiltro è null/undefined, passa null per caricare tutte le richieste senza filtro anno
      this.caricaRichieste(
        this.statoFiltro,
        annoFiltro,
        this.isEnteEsecutore ? this.enteId : enteFiltro,
      );
    });
  }

  caricaRichieste(
    stato: string | number | null,
    anno: string | number | null,
    enteEsecutore: string | null,
  ) {
    // Assicurati che l'ente sia sempre filtrato se l'utente è un ENTE_ESECUTORE
    const enteEffettivo = this.isEnteEsecutore ? this.enteId : enteEsecutore;

    // Simulazione caricamento dati (da sostituire con chiamata reale al servizio)
    this.richiesteCaricate = false;
    console.log(
      `[RICHIESTE] caricaRichieste chiamato con: stato=${stato}, anno=${anno}, ente=${enteEffettivo}, isEnteEsecutore=${this.isEnteEsecutore}`,
    );

    // Genera dati di esempio
    //setTimeout(() => {
    this.richiesteService
      .getRichiesteFiltrate(stato, anno, enteEffettivo)
      .subscribe((richieste) => {
        this.richieste = richieste;
        // Salva una copia dei dati originali (solo se non ci sono filtri attivi, altrimenti mantieni quelli già salvati)
        if (!this.filtriAttivi || this.richiesteOriginali.length === 0) {
          this.richiesteOriginali = [...richieste];
        }
        this.richiesteCaricate = true;

        // Forza il change detection per assicurarsi che la tabella venga renderizzata
        this.cdr.detectChanges();

        // Riapplica il filtro di testo globale se presente
        if (this.filtroTestoGlobale && this.filtroTestoGlobale.length > 0) {
          // Usa un approccio più robusto per attendere che la tabella sia renderizzata
          this.riapplicaFiltroTestoGlobale();
        }

        // Controlla se esistono richieste per l'anno successivo solo per utenti UMVS/ADMIN
        // E solo se non ci sono filtri attivi e stiamo guardando l'anno corrente
        if (
          !this.isEnteEsecutore &&
          !this.filtriAttivi &&
          this.filtri.anno != this.annoCorrente + 1
        ) {
          this.richiesteService
            .getRichiesteFiltrate(stato, this.annoCorrente + 1, enteEffettivo)
            .subscribe((richiesteAnnoSuccessivo) => {
              this.richiesteAnnoSuccessivoSonoPresenti =
                richiesteAnnoSuccessivo.length > 0;
            });
        }
      });
    //}, 800);
  }

  /**
   * Metodo per aggiornare le richieste mantenendo i filtri attivi
   * Usa i valori correnti dei filtri (anno, stato) e riapplica il filtro di testo globale
   * Funziona anche senza query parameters e per ente esecutore
   */
  aggiornaRichieste(): void {
    // Usa i valori correnti dei filtri invece di statoFiltro, annoCorrente, enteFiltro
    // Se i filtri non sono stati inizializzati (nessun query param), usa i valori correnti o di default
    let statoCorrente = this.filtri.stato;
    let annoCorrente = this.filtri.anno;
    const enteCorrente = this.isEnteEsecutore
      ? this.enteId
      : this.filtri.enteEsecutore;

    // Se i filtri non sono stati inizializzati, usa i valori correnti o di default
    if (statoCorrente === null || statoCorrente === undefined) {
      statoCorrente = this.statoFiltro;
    }
    if (
      annoCorrente === null ||
      annoCorrente === undefined ||
      annoCorrente === 0
    ) {
      annoCorrente = this.annoCorrente || this.annoAttualeReale;
    }

    // Aggiorna anche statoFiltro e annoCorrente per coerenza
    this.statoFiltro = statoCorrente;
    this.annoCorrente = annoCorrente;

    // Aggiorna anche il modello dei filtri per assicurarsi che siano sincronizzati
    this.filtri.stato = statoCorrente;
    this.filtri.anno = annoCorrente as number | null;
    if (!this.isEnteEsecutore) {
      this.filtri.enteEsecutore = enteCorrente;
    } else {
      // Per ente esecutore, assicurati che enteEsecutore sia sempre l'enteId
      this.filtri.enteEsecutore = this.enteId;
    }

    console.log(
      `[RICHIESTE] aggiornaRichieste chiamato con: stato=${statoCorrente}, anno=${annoCorrente}, ente=${enteCorrente}, filtroTesto=${this.filtroTestoGlobale}`,
    );

    // Carica le richieste con i filtri correnti
    // Il metodo caricaRichieste riapplicherà automaticamente il filtro di testo globale
    this.caricaRichieste(statoCorrente, annoCorrente, enteCorrente);
  }

  openCaricaAzioni(event: any, richiesta: Richiesta): Promise<void> {
    this.selectedRichiesta = richiesta;
    this.loadAzioni(event, richiesta);
    this.azioniMenuTiered.toggle(event);
    return Promise.resolve();
  }

  loadAzioni(event: any, richiesta: Richiesta) {
    this.menuAzioniItems = [];
    let itemsInterventi: any[] = [
      {
        label: 'Apri',
        icon: PrimeIcons.EYE,
        style: { 'font-weight': 'bold', 'font-size': '12px' },
        command: () => this.apriInterventi(richiesta),
      },
      {
        label: 'Mostra su mappa',
        icon: PrimeIcons.MAP_MARKER,
        style: { 'font-weight': 'bold', 'font-size': '12px' },
        command: () => this.mostraInterventiSuMappa(richiesta),
      },
    ];
    this.menuAzioniItems.push(
      {
        label: 'Storico',
        icon: PrimeIcons.HISTORY,
        style: {
          'font-size': '12px',
        },
        command: () => this.mostraStoricoRichiesta(richiesta),
      },
      {
        label: 'Mostra interventi',
        icon: PrimeIcons.WRENCH,
        //icon: 'icona-interventi',
        style: {
          'font-size': '12px',
        },
        command: () => this.apriInterventi(richiesta),
      },
    );
    if (richiesta.stato.descrizione.toUpperCase() == 'IN PREPARAZIONE') {
      if (!this.isEnteEsecutore) {
        if (richiesta.enteEsecutore.label.toUpperCase() == 'UMVS') {
          if (richiesta.importoRichiesto > 0) {
            this.menuAzioniItems.push({
              label: 'Fine preparazione',
              icon: PrimeIcons.CHECK_CIRCLE,
              style: {
                'font-size': '12px',
                'font-weight': 'bold',
              },
              command: () => this.comunicaFinePreparazione(richiesta),
            });
          }
        }
        this.menuAzioniItems.push({
          label: 'Elimina',
          icon: PrimeIcons.ERASER,
          style: {
            'font-size': '11.7px',
            'font-weight': 'bold',
          },
          command: () => this.eliminaRichiesta(richiesta),
        });
      } else {
        if (richiesta.importoRichiesto > 0) {
          this.menuAzioniItems.push({
            label: 'Fine preparazione',
            icon: PrimeIcons.CHECK_CIRCLE,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () => this.comunicaFinePreparazione(richiesta),
          });
        }
      }
    }
    //azioni admin
    if (!this.isEnteEsecutore) {
      if (richiesta.stato.descrizione.toUpperCase() == 'IN PREPARAZIONE') {
      } else if (richiesta.stato.descrizione.toUpperCase() == 'PRESENTATA') {
        this.menuAzioniItems.push({
          label: 'Modifica',
          icon: PrimeIcons.PENCIL,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.modificaRichiesta(richiesta),
        });

        if (!richiesta.importoContributo || richiesta.importoContributo == 0) {
          let labelContributo = 'Comunica contributo';
          this.menuAzioniItems.push({
            label: labelContributo,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            icon: PrimeIcons.MONEY_BILL,
            command: () => this.comunicaContributo(richiesta),
          });
        } else {
        }

        //CARICAMENTO PDF LETTERA INVIATA AL COMUNE

        // Aggiungo l'azione per confermare il finanziamento
        /* this.menuAzioniItems.push({
          label: "Conferma finanziamento",
          icon: PrimeIcons.CHECK_CIRCLE,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.confermaFinanziamento(richiesta),
        }); */
      } else if (richiesta.stato.descrizione.toUpperCase() == 'DA FINANZIARE') {
        /*  this.menuAzioniItems.push({
          label: "Variante",
          icon: PrimeIcons.FILE_EDIT,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.creaVariante(richiesta),
        }); */

        if (
          richiesta.importoRimodulato &&
          richiesta.importoRimodulato > 0 &&
          Math.round(richiesta.importoRimodulato * 100) / 100 >=
            Math.round(richiesta.importoContributo * 100) / 100
        ) {
          this.menuAzioniItems.push({
            label: 'Finanzia',
            icon: PrimeIcons.CART_PLUS,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () => this.finanziaRichiesta(richiesta),
          });
        }

        if (richiesta.importoContributo && richiesta.importoContributo > 0) {
          // Se il contributo è stato comunicato, aggiungi menu raggruppato CONTRIBUTO
          this.menuAzioniItems.push({
            label: 'Contributo',
            icon: PrimeIcons.MONEY_BILL,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            items: [
              {
                label: 'Modifica',
                icon: PrimeIcons.PENCIL,
                style: {
                  'font-size': '12px',
                },
                command: () => this.comunicaContributo(richiesta),
              },
              {
                label: 'Storico',
                icon: PrimeIcons.HISTORY,
                style: {
                  'font-size': '12px',
                },
                command: () => this.mostraStoricoContributi(richiesta),
              },
            ],
          });
        }
      } else if (richiesta.stato.descrizione.toUpperCase() == 'FINANZIATA') {
        this.menuAzioniItems.push({
          label: 'Variante',
          icon: PrimeIcons.FILE_EDIT,
          style: {
            'font-size': '12px',
            'font-weight': 'bold',
          },
          command: () => this.creaVariante(richiesta),
        });
        if (richiesta.allegatoPdf) {
          this.menuAzioniItems.push({
            label: 'Scarica lettera ATO',
            icon: PrimeIcons.FILE_PDF,
            style: {
              'font-size': '12px',
            },
            command: () => this.scaricaPDF(richiesta),
          });
        } else {
          this.menuAzioniItems.push({
            label: 'Carica lettera ATO',
            icon: PrimeIcons.FILE_PDF,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () => this.caricaLetteraInviata(richiesta),
          });
        }
        if (richiesta.importoContributo && richiesta.importoContributo > 0) {
          // Se il contributo è stato comunicato, aggiungi menu raggruppato CONTRIBUTO
          this.menuAzioniItems.push({
            label: 'Contributo',
            icon: PrimeIcons.MONEY_BILL,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            items: [
              {
                label: 'Modifica',
                icon: PrimeIcons.PENCIL,
                style: {
                  'font-size': '12px',
                },
                command: () => this.comunicaContributo(richiesta),
              },
              {
                label: 'Storico',
                icon: PrimeIcons.HISTORY,
                style: {
                  'font-size': '12px',
                },
                command: () => this.mostraStoricoRichiesta(richiesta),
              },
            ],
          });
        }
      } else if (
        richiesta.stato.descrizione.toUpperCase() == 'IN RENDICONTAZIONE' ||
        richiesta.stato.descrizione.toUpperCase() == 'RENDICONTATA'
      ) {
        if (richiesta.importoContributo && richiesta.importoContributo > 0) {
          // Se il contributo è stato comunicato, aggiungi menu raggruppato CONTRIBUTO
          this.menuAzioniItems.push({
            label: 'Contributo',
            icon: PrimeIcons.MONEY_BILL,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            items: [
              {
                label: 'Modifica',
                icon: PrimeIcons.PENCIL,
                style: {
                  'font-size': '12px',
                },
                command: () => this.comunicaContributo(richiesta),
              },
              {
                label: 'Storico',
                icon: PrimeIcons.HISTORY,
                style: {
                  'font-size': '12px',
                },
                command: () => this.mostraStoricoRichiesta(richiesta),
              },
            ],
          });
        }
        this.menuAzioniItems.push(
          {
            label: 'Variante',
            icon: PrimeIcons.FILE_EDIT,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () => this.creaVariante(richiesta),
          },
          {
            label: 'Determine',
            icon: PrimeIcons.BOOK,
            style: {
              'font-size': '12px',
              'font-weight': 'bold',
            },
            command: () =>
              this.assegnaMassivamenteDetermineDaUnaRichiesta(richiesta),
          },
        );
      }
    }
    if (
      this.isEnteEsecutore &&
      richiesta.stato.descrizione.toUpperCase() == 'FINANZIATA'
    ) {
      // Gli enti esecutori NON possono vedere/modificare il contributo
      if (richiesta.allegatoPdf) {
        this.menuAzioniItems.push({
          label: 'Scarica lettera ATO',
          icon: PrimeIcons.FILE_PDF,
          style: {
            'font-size': '12px',
          },
          command: () => this.scaricaPDF(richiesta),
        });
      }
    }

    /*  if(richiesta.allegatoPdf  ){
      this.menuAzioniItems.push({
        label: "Scarica lettera ATO",
        icon: PrimeIcons.FILE_PDF,
        style: {
          'font-size': '12px'
        },
        command: () => this.scaricaPDF(richiesta),
      });
    }else{
      this.menuAzioniItems.push({
        label: "Carica lettera ATO",
        icon: PrimeIcons.FILE_PDF,
        style: {
          'font-size': '12px',
          'font-weight': 'bold'
        },
        command: () => this.caricaLetteraInviata(richiesta),
      });
    } */

    //azioni ente esecutore
    /*  if(this.isEnteEsecutore){
      if(richiesta.stato.descrizione.toUpperCase() == "IN PREPARAZIONE"){
        this.menuAzioniItems.push({
          label: "Dichiara pronta",
          icon: PrimeIcons.CHECK_CIRCLE,
          style: {
            'font-size': '12px',
            'font-weight': 'bold'
          },
          command: () => this.dichiaraPronta(richiesta),
        });
      }
    } */
  }

  modificaRichiesta(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Modifica richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.modificaRichiestaComponent.show(richiesta);
  }

  onModificaCompletata() {
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
    if (this.isEnteEsecutore || this.isAdminOrUmvs) {
      this.caricaStoricoRichieste();
    }
  }

  caricaLetteraInviata(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Carica lettera inviata richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.mostraCaricaLettera = true;
  }

  scaricaPDF(richiesta: Richiesta) {
    this.isDownloading = true;
    const path = `richieste/${richiesta.id}/allegati`;
    this.firebaseStorageService.listFiles(path).subscribe({
      next: (files) => {
        files.forEach((fileName) => {
          //this.logger.info('[RICHIESTE] Scaricamento lettera ATO', fileName);
          this.firebaseStorageService.downloadFile(`${fileName}`).subscribe({
            next: (blob: Blob) => {
              // Estrai il nome del file dal path completo rimuovendo i parametri di query
              const nomeFile = decodeURIComponent(
                fileName.split('/').pop()?.split('?')[0] || fileName,
              );
              const nomeFileFinale = nomeFile.split('/').pop() || nomeFile;
              //this.logger.info('[RICHIESTE] Nome file estratto:', nomeFileFinale);
              saveAs(blob, nomeFileFinale);
              this.isDownloading = false;
            },
            error: (error: Error) => {
              this.logger.error(
                `[RICHIESTE] Errore durante il download del file ${fileName}:`,
                error,
              );
              this.messageService.add({
                severity: 'error',
                summary: 'Errore',
                detail: `Impossibile scaricare il file ${fileName}`,
              });
              this.isDownloading = false;
            },
          });
        });
      },
      error: (error: Error) => {
        this.logger.error(
          '[INTERVENTI] Errore durante il recupero della lista dei file:',
          error,
        );
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile recuperare la lista dei file',
        });
        this.isDownloading = false;
      },
    });
  }

  onUploadLetteraCompletato(event: { richiestaId: number; nomeFile: string }) {
    //this.logger.info(`[RICHIESTE] Upload completato per richiestaId: ${event.richiestaId}, nomeFile: ${event.nomeFile}`);

    // Qui aggiungere codice per aggiornare la richiesta o fare altre operazioni post-upload
    // Per esempio, potrebbe essere necessario aggiornare lo stato della richiesta

    this.messageService.add({
      severity: 'success',
      summary: 'Lettera caricata',
      detail: `La lettera "${event.nomeFile}" è stata caricata con successo`,
      life: 5000,
    });

    // Aggiorna la lista delle richieste per mostrare eventuali cambiamenti
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
  }

  apriInterventi(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Apri interventi richiesta ${richiesta.id} e anno ${richiesta.anno}`);

    // Salva i filtri correnti prima di navigare
    // Per ENTE_ESECUTORE non salviamo mai il filtro ente, per UMVS/ADMIN solo se effettivamente attivo
    this.filtriStatoService.salvaFiltriRichieste({
      anno: this.filtri.anno || this.annoAttualeReale,
      stato: this.filtri.stato,
      ente: this.isEnteEsecutore ? null : this.filtri.enteEsecutore,
    });

    this.router.navigate(['/interventi'], {
      queryParams: { ente: this.enteId, richiestaId: richiesta.id },
      replaceUrl: true, // Sostituisce l'URL corrente senza aggiungere una nuova entry nella history
    });
  }

  mostraStoricoRichiesta(richiesta: Richiesta) {
    if (richiesta && richiesta.id) {
      //this.logger.info(`[RICHIESTE] Mostra storico richiesta ${richiesta.id}`);
      this.richiestaIdStorico = richiesta.id;
      this.storicoRichiestaComponent.show(richiesta);
      //this.titoloStorico = `Storico della Richiesta dell'ente <span class="font-bold">${(richiesta.enteEsecutore?.label || '').toUpperCase()}</span> per l'anno ${richiesta.anno}`;

      // this.mostraStorico      = true;
    }
  }

  mostraStoricoContributi(richiesta: Richiesta) {
    if (richiesta && richiesta.id) {
      this.logger.info(
        `[RICHIESTE] Mostra storico contributi richiesta ${richiesta.id}`,
      );
      this.storicoContributiComponent.show(richiesta);
    }
  }

  mostraInterventiSuMappa(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Mostra interventi su mappa richiesta ${richiesta.id}`);
  }

  comunicaContributo(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Comunica contributo richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.mostraComunicaContributo = true;
  }

  finanziaRichiesta(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Finanzia richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.confermaFinanziamentoComponent.show(richiesta);
    //  this.mostraFinanziaRichiesta = true;
  }

  creaVariante(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Crea variante richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.varianteComponent.show(richiesta);
  }
  onVarianteCreata() {
    //this.logger.info(`[RICHIESTE] Variante creata ${event.importoFinanziato} per richiesta ${event.richiestaId}`);
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
    if (this.isEnteEsecutore || this.isAdminOrUmvs) {
      this.caricaStoricoRichieste();
    }
  }
  onFinanziamentoCompletato(event: {
    richiestaId: number;
    importoFinanziato: number;
  }) {
    //this.logger.info(`[RICHIESTE] Finanziamento completato ${event.importoFinanziato} per richiesta ${event.richiestaId}`);
    // this.mostraFinanziaRichiesta = false;
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
  }

  onConfermaComunicaContributo(event: {
    richiestaId: number;
    importoContributo: number;
  }) {
    //this.logger.info(`[RICHIESTE] Confermato contributo ${event.importoContributo} per richiesta ${event.richiestaId}`);

    // Qui chiamata API per salvare il contributo
    // ...

    // Aggiorno la richiesta locale e mostro un messaggio
    const richiesta = this.richieste.find((r) => r.id === event.richiestaId);
    if (richiesta) {
      richiesta.importoContributo = event.importoContributo;

      this.messageService.add({
        severity: 'success',
        summary: 'Contributo comunicato',
        detail: `Contributo di ${event.importoContributo.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' })} assegnato all'ente ${richiesta.enteEsecutore?.label}`,
        life: 5000,
      });
      this.mostraComunicaContributo = false;
      this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
      if (this.isEnteEsecutore || this.isAdminOrUmvs) {
        this.caricaStoricoRichieste();
      }
    }
  }

  /**
   * Inizializza il menu dei report con le 3 opzioni
   * I report Regione sono visibili solo agli utenti NON ente esecutore
   */
  initMenuReport() {
    this.menuReportItems = [
      {
        label: 'Standard',
        icon: 'pi pi-file-excel',
        command: () => this.scaricaReportRichieste(),
        tooltip: 'Scarica il report standard delle richieste',
      },
    ];

    // Aggiungi i report Regione solo se l'utente NON è un ente esecutore
    if (!this.isEnteEsecutore) {
      this.menuReportItems.push(
        {
          label: 'Regione - Annuale',
          icon: 'pi pi-calendar',
          command: () => this.scaricaReportRegioneAnnuale(),
          tooltip: 'Scarica il report annuale per la regione',
        },
        {
          label: 'Regione - Mensile',
          icon: 'pi pi-calendar-times',
          command: () => this.scaricaReportRegioneMensile(),
          tooltip: 'Scarica il report mensile per la regione',
        },
      );
    }
  }

  /**
   * Apre il menu dei report
   */
  apriMenuReport(event: Event) {
    this.menuReport.toggle(event);
  }

  scaricaReportRichieste() {
    //this.logger.info('[RICHIESTE] Avvio download richieste');
    this.excelService.exportRichiesteToExcel(
      this.richieste,
      'report_richieste.xlsx',
      true,
    );
  }

  scaricaReportRegioneAnnuale() {
    // Inizializza con l'anno corrente
    this.annoReportSelezionato = this.annoAttualeReale;
    this.mostraReportAnnuale = true;
  }

  scaricaReportRegioneMensile() {
    // Inizializza con anno e mese corrente
    this.annoReportSelezionato = this.annoAttualeReale;
    this.meseReportSelezionato = new Date().getMonth() + 1;
    this.mostraReportMensile = true;
  }

  confermaReportAnnuale() {
    const annoRiferimento = this.annoReportSelezionato;
    this.logger.info(
      `[RICHIESTE] Generazione report regione annuale per l'anno ${annoRiferimento}`,
    );
    this.mostraReportAnnuale = false;
    this.isDownloading = true;

    this.interventiService.getInterventi().subscribe({
      next: (interventi) => {
        const filename = `report_regione_annuale_${annoRiferimento}.xlsx`;
        this.excelService.exportReportRegioneAnnualeToExcel(
          interventi,
          annoRiferimento,
          filename,
          true,
        );

        this.messageService.add({
          severity: 'success',
          summary: 'Report generato',
          detail: `Report annuale generato per l'anno ${annoRiferimento}.`,
          life: 5000,
        });
        this.isDownloading = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante la generazione del report annuale.',
          life: 5000,
        });
        this.isDownloading = false;
      },
    });
  }

  confermaReportMensile() {
    const nomeMese =
      this.mesiDisponibili.find((m) => m.value === this.meseReportSelezionato)
        ?.label ?? `${this.meseReportSelezionato}`;
    this.logger.info(
      `[RICHIESTE] Generazione report regione mensile per ${nomeMese} ${this.annoReportSelezionato}`,
    );
    this.mostraReportMensile = false;
    this.isDownloading = true;

    this.interventiService.getInterventi().subscribe({
      next: (interventi) => {
        const filename = `report_regione_mensile_${this.annoReportSelezionato}_${String(this.meseReportSelezionato).padStart(2, '0')}.xlsx`;
        this.excelService.exportReportRegioneMensileToExcel(
          interventi,
          this.annoReportSelezionato,
          this.meseReportSelezionato,
          filename,
          true,
        );

        this.messageService.add({
          severity: 'success',
          summary: 'Report generato',
          detail: `Report mensile generato per ${nomeMese} ${this.annoReportSelezionato}.`,
          life: 5000,
        });
        this.isDownloading = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante la generazione del report mensile.',
          life: 5000,
        });
        this.isDownloading = false;
      },
    });
  }

  annullaReportAnnuale() {
    this.mostraReportAnnuale = false;
  }

  annullaReportMensile() {
    this.mostraReportMensile = false;
  }

  generaRichieste() {
    this.mostraGeneraRichieste = true;
  }

  onRichiesteGenerate(event: { enteIds: number[]; count: number }) {
    //this.logger.info(`[RICHIESTE] Generate ${event.count} richieste per l'anno ${this.annoCorrente}`);

    // Mostra un messaggio di successo
    this.messageService.add({
      severity: 'success',
      summary: 'Richieste generate',
      detail: `Generate ${event.count} richieste per l'anno ${this.annoCorrente}`,
      life: 5000,
    });

    // Ricarica le richieste per mostrare quelle appena create
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
  }

  cambiaStatoRichiesta(richiesta: any, nuovoStato: string) {
    // Implementazione esempio per il cambio di stato
    const vecchioStato = richiesta.stato;
    richiesta.stato = nuovoStato;

    //this.logger.info(`[RICHIESTE] Cambiato stato richiesta ${richiesta.id} da ${vecchioStato} a ${nuovoStato}`);

    // Notifica utente
    this.messageService.add({
      severity: 'info',
      summary: 'Stato aggiornato',
      detail: `Richiesta ${richiesta.id} aggiornata a "${nuovoStato}"`,
      life: 3000,
    });
  }

  comunicaFinePreparazione(richiesta: any) {
    //this.logger.info(`[RICHIESTE] Comunica fine preparazione richiesta ${richiesta.id}`);
    // this.richiestaSelezionata = richiesta;
    this.chiudiPreparazioneRichiestaComponent.show(richiesta);
  }

  eliminaRichiesta(richiesta: any) {
    this.richiestaSelezionata = richiesta;
    this.mostraConfermaEliminazione = true;
  }

  onEliminazioneConfermata(richiestaId: number) {
    //this.logger.info(`[RICHIESTE] Eliminazione richiesta ID: ${richiestaId}`);

    this.richiesteService.elimina(richiestaId).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Richiesta eliminata',
          detail: 'La richiesta è stata eliminata con successo',
          life: 5000,
        });

        // Ricarica le richieste dopo l'eliminazione
        this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: "Errore durante l'eliminazione della richiesta",
        });
      },
    });
  }

  getStatoSeverity(
    stato: string,
  ): 'success' | 'info' | 'warning' | 'danger' | 'secondary' | 'contrast' {
    switch (stato) {
      case 'in preparazione':
        return 'info';
      case 'presentata':
        return 'secondary';
      case 'finanziata':
        return 'success';
      case 'rendicontata':
        return 'warning';
      case 'in liquidazione':
        return 'warning';
      case 'liquidata':
        return 'success';
      default:
        return 'info';
    }
  }

  apriFiltri(): void {
    this.mostraFiltri = true;
  }

  applicaFiltri(): void {
    this.mostraFiltri = false;

    // Verifica se sono stati applicati filtri
    const annoDefault = this.annoAttualeReale;
    this.filtriAttivi =
      this.filtri.stato !== null ||
      (!this.isEnteEsecutore && this.filtri.enteEsecutore !== null) ||
      this.filtri.anno !== annoDefault;

    // Navighiamo all'URL con i parametri di query per i filtri
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        anno: this.filtri.anno,
        stato: this.filtri.stato,
        ente: this.isEnteEsecutore ? this.enteId : this.filtri.enteEsecutore,
      },
      queryParamsHandling: 'merge', // mantiene i parametri di query esistenti
    });
    this.annoCorrente = this.filtri.anno || this.annoAttualeReale;
    // Carica le richieste con i nuovi filtri
    this.caricaRichieste(
      this.filtri.stato,
      this.filtri.anno,
      this.filtri.enteEsecutore,
    );
  }

  /**
   * Metodo helper per verificare se ci sono filtri attivi
   * Il pulsante "Rimuovi tutti i filtri" appare solo se ci sono filtri attivi
   * "Tutti gli anni" (filtri.anno === null) non conta come filtro attivo
   * L'anno corrente (filtri.anno === annoAttualeReale) non conta come filtro attivo se è l'unico filtro
   */
  verificaFiltriAttivi(): boolean {
    const annoDefault = this.annoAttualeReale;
    const annoSelezionato =
      this.filtri.anno !== null && this.filtri.anno !== annoDefault;
    const altriFiltriAttivi =
      this.filtri.stato !== null ||
      this.filtroTestoGlobale.length > 0 ||
      (!this.isEnteEsecutore && this.filtri.enteEsecutore !== null);

    // Il pulsante appare solo se:
    // - C'è un anno diverso dall'anno corrente selezionato, OPPURE
    // - Ci sono altri filtri attivi (stato, testo, ente)
    return annoSelezionato || altriFiltriAttivi;
  }

  // Metodo per i filtri inline - applicazione immediata
  applicaFiltriInline(): void {
    // Verifica se sono stati applicati filtri
    this.filtriAttivi = this.verificaFiltriAttivi();

    // Prepara i query params, escludendo stato se è null o 'remove-filter'
    const queryParams: any = {};
    if (this.filtri.anno) {
      queryParams.anno = this.filtri.anno;
    }
    // Includi stato solo se è un valore valido (non null e non 'remove-filter')
    if (this.filtri.stato && this.filtri.stato !== 'remove-filter') {
      queryParams.stato = this.filtri.stato;
    }
    if (this.isEnteEsecutore && this.enteId) {
      queryParams.ente = this.enteId;
    } else if (!this.isEnteEsecutore && this.filtri.enteEsecutore) {
      queryParams.ente = this.filtri.enteEsecutore;
    }

    // Navighiamo all'URL con i parametri di query per i filtri
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });
    this.annoCorrente = this.filtri.anno || this.annoAttualeReale;
    // Carica le richieste con i nuovi filtri
    this.caricaRichieste(
      this.filtri.stato,
      this.filtri.anno,
      this.filtri.enteEsecutore,
    );
  }

  resetFiltri(): void {
    this.filtri = {
      anno: this.annoAttualeReale,
      stato: null,
      enteEsecutore: this.isEnteEsecutore ? this.enteId : null,
    };
  }

  azzeraTuttiFiltri(): void {
    // Reset dei filtri ma mantieni il filtro per ente se l'utente è un ENTE_ESECUTORE
    // resetFiltri() imposta già l'anno all'anno corrente (annoAttualeReale)
    this.resetFiltri();

    // Aggiorna l'anno corrente per il titolo
    this.annoCorrente = this.annoAttualeReale;
    // Assicurati che filtri.anno sia impostato all'anno corrente
    this.filtri.anno = this.annoAttualeReale;

    // Aggiorna il flag dei filtri attivi dopo aver azzerato i filtri
    this.filtriAttivi = this.verificaFiltriAttivi();

    // Reset tabella e filtro di testo globale
    if (this.dt) {
      this.dt.reset();
      this.dt.filterGlobal('', 'contains');
    }
    this.filtroTestoGlobale = '';

    // Prepara i query params con l'anno corrente
    const queryParams: any = {};
    if (!this.isEnteEsecutore) {
      // Per gli enti non esecutori, aggiungi l'anno corrente
      queryParams.anno = this.annoAttualeReale;
    } else if (this.isEnteEsecutore && this.enteId) {
      // Per gli enti esecutori, aggiungi solo l'ente
      queryParams.ente = this.enteId;
      queryParams.anno = this.annoAttualeReale;
    }

    // Naviga all'URL con l'anno corrente nei query params
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: queryParams,
      replaceUrl: true,
    });

    // Ricarica i dati con l'anno corrente (come al primo caricamento)
    console.log(
      '[RICHIESTE] Azzeramento filtri - caricamento richieste con anno corrente:',
      this.annoAttualeReale,
    );
    this.caricaRichieste(
      null,
      this.annoAttualeReale,
      this.filtri.enteEsecutore,
    );

    // Forza il change detection per aggiornare il titolo
    this.cdr.detectChanges();
  }

  pulisciFiltroGlobale() {
    this.filtroTestoGlobale = '';
    if (this.dt) {
      this.dt.filterGlobal('', 'contains');
    }
    // Aggiorna il flag dei filtri attivi dopo aver pulito il filtro di testo
    this.filtriAttivi = this.verificaFiltriAttivi();
  }

  onFiltroGlobaleChange(event: Event) {
    if (this.dt) {
      // Casting esplicito di event.target a HTMLInputElement per accedere a value
      const inputValue = (event.target as HTMLInputElement).value;
      this.dt.filterGlobal(inputValue, 'contains');
    }
    // Aggiorna il flag dei filtri attivi quando cambia il filtro di testo
    this.filtriAttivi = this.verificaFiltriAttivi();
  }

  /**
   * Metodo per gestire il cambio del filtro anno
   */
  onAnnoChange(event: any): void {
    console.log(
      '[RICHIESTE] onAnnoChange chiamato con event.value:',
      event.value,
    );
    console.log('[RICHIESTE] event completo:', event);

    // Controlla se è l'opzione "Rimuovi filtro" (può essere null o un oggetto con isRemoveOption)
    if (
      !event.value ||
      (event.value &&
        (event.value.isRemoveOption || event.value.id === 'remove-filter')) ||
      (typeof event.value === 'object' && event.value.anno === 'Rimuovi filtro')
    ) {
      console.log('[RICHIESTE] Rimozione filtro anno rilevata');
      // Salva l'anno precedente prima di rimuoverlo, così il listener può capire che è stato rimosso
      if (this.filtri.anno !== null) {
        this.annoPrecedente = this.filtri.anno;
      }
      // Rimuovi il filtro anno quando viene selezionata l'opzione "Rimuovi filtro"
      // Imposta esplicitamente a null per indicare che è stato rimosso
      this.filtri.anno = null;
      // Assicurati che annoCorrente non mostri l'anno nel titolo
      // Il titolo usa filtri.anno, quindi non serve aggiornare annoCorrente

      // Imposta un flag per indicare che stiamo rimuovendo il filtro
      // così il listener può distinguere tra "primo caricamento" e "rimozione filtro"
      this.rimozioneFiltroAnno = true;

      // Forza il change detection per aggiornare il titolo immediatamente
      this.cdr.detectChanges();
      // Non impostare annoCorrente quando il filtro viene rimosso, così il titolo non mostra l'anno
      // this.annoCorrente rimane invariato per non mostrare l'anno nel titolo

      // Aggiorna il flag dei filtri attivi
      this.filtriAttivi = this.verificaFiltriAttivi();

      // Prepara i query params senza il parametro anno
      const queryParams: any = {};
      if (this.filtri.stato) {
        queryParams.stato = this.filtri.stato;
      }
      if (!this.isEnteEsecutore && this.filtri.enteEsecutore) {
        queryParams.ente = this.filtri.enteEsecutore;
      } else if (this.isEnteEsecutore && this.enteId) {
        queryParams.ente = this.enteId;
      }

      // Naviga all'URL senza il filtro anno (rimuove il parametro anno se presente)
      // Usa replaceUrl: true per non aggiungere una nuova entry nella cronologia del browser
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        replaceUrl: true,
      });

      // Chiama direttamente caricaRichieste() con anno = null per caricare tutte le richieste
      // Il listener queryParams.subscribe() potrebbe non essere chiamato quando rimuoviamo solo un parametro
      console.log(
        '[RICHIESTE] Rimozione filtro anno - caricamento richieste senza filtro anno',
      );
      this.caricaRichieste(
        this.filtri.stato,
        null,
        this.isEnteEsecutore ? this.enteId : this.filtri.enteEsecutore,
      );
      return;
    }

    // Se è un anno valido (numero), applica il filtro normalmente
    if (event.value) {
      const annoValue =
        typeof event.value === 'number'
          ? event.value
          : event.value.anno || event.value;
      if (typeof annoValue === 'number') {
        // Imposta il flag per evitare che il listener chiami caricaRichieste() di nuovo
        this.cambioFiltroAnnoInCorso = true;

        this.filtri.anno = annoValue;
        this.annoCorrente = annoValue;

        // Aggiorna il flag dei filtri attivi
        this.filtriAttivi = this.verificaFiltriAttivi();

        // Prepara i query params
        const queryParams: any = {};
        if (this.filtri.anno) {
          queryParams.anno = this.filtri.anno;
        }
        if (this.filtri.stato) {
          queryParams.stato = this.filtri.stato;
        }
        if (this.isEnteEsecutore && this.enteId) {
          queryParams.ente = this.enteId;
        } else if (!this.isEnteEsecutore && this.filtri.enteEsecutore) {
          queryParams.ente = this.filtri.enteEsecutore;
        }

        // Naviga all'URL con i parametri di query per i filtri
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: queryParams,
          replaceUrl: true, // Evita di aggiungere una nuova entry nella cronologia
        });

        // Chiama direttamente caricaRichieste() per evitare problemi con il listener
        console.log(
          '[RICHIESTE] Applicazione filtro anno - caricamento richieste con anno:',
          this.filtri.anno,
        );
        this.caricaRichieste(
          this.filtri.stato,
          this.filtri.anno,
          this.filtri.enteEsecutore,
        );

        // Reset del flag dopo un breve delay per permettere al listener di vedere il flag
        setTimeout(() => {
          this.cambioFiltroAnnoInCorso = false;
        }, 100);
      }
    }
  }

  /**
   * Metodo per gestire il cambio del filtro stato
   */
  onStatoChange(event: any): void {
    console.log(
      '[RICHIESTE] onStatoChange chiamato con event.value:',
      event.value,
    );
    console.log('[RICHIESTE] event completo:', event);
    console.log('[RICHIESTE] filtri.stato corrente:', this.filtri.stato);

    // Controlla se è l'opzione "Tutti gli stati" (Rimuovi filtro)
    // Può essere null, undefined, 'remove-filter', o un oggetto con isRemoveOption/id/value === 'remove-filter'
    if (
      !event.value ||
      event.value === 'remove-filter' ||
      (event.value &&
        (event.value.isRemoveOption ||
          event.value.id === 'remove-filter' ||
          event.value.value === 'remove-filter' ||
          (typeof event.value === 'object' &&
            event.value.label === 'Tutti gli stati')))
    ) {
      console.log('[RICHIESTE] Rimozione filtro stato rilevata');
      // Rimuovi il filtro stato quando viene selezionata l'opzione "Tutti gli stati"
      // Imposta esplicitamente a null per evitare che venga passato 'remove-filter'
      this.filtri.stato = null;

      // Aggiorna il flag dei filtri attivi
      this.filtriAttivi = this.verificaFiltriAttivi();

      // Prepara i query params senza il parametro stato
      const queryParams: any = {};
      if (this.filtri.anno) {
        queryParams.anno = this.filtri.anno;
      }
      if (this.isEnteEsecutore && this.enteId) {
        queryParams.ente = this.enteId;
      } else if (!this.isEnteEsecutore && this.filtri.enteEsecutore) {
        queryParams.ente = this.filtri.enteEsecutore;
      }

      // Naviga all'URL senza il filtro stato
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        replaceUrl: true,
      });

      // Ricarica le richieste senza il filtro stato
      console.log('[RICHIESTE] Ricaricamento richieste senza filtro stato');
      this.caricaRichieste(
        null,
        this.filtri.anno,
        this.isEnteEsecutore ? this.enteId : this.filtri.enteEsecutore,
      );
      return;
    }

    // Se è uno stato valido, applica il filtro normalmente
    if (this.isStatoValido(event.value)) {
      this.filtri.stato = event.value.value || event.value;
      this.applicaFiltriInline();
    }
  }

  /**
   * Metodo helper per verificare se un anno è valido (non è l'opzione "Rimuovi filtro")
   */
  isAnnoValido(anno: any): boolean {
    if (!anno) return false;
    // Se è un numero, è valido
    if (typeof anno === 'number') return true;
    // Se è un oggetto, controlla che non sia l'opzione "Rimuovi filtro"
    return (
      !anno.isRemoveOption &&
      anno.id !== 'remove-filter' &&
      typeof (anno.anno || anno) === 'number'
    );
  }

  /**
   * Metodo helper per verificare se uno stato è valido (non è l'opzione "Rimuovi filtro")
   */
  isStatoValido(stato: any): boolean {
    return (
      stato &&
      !stato.isRemoveOption &&
      stato.id !== 'remove-filter' &&
      stato.value !== 'remove-filter'
    );
  }

  /**
   * Metodo helper per ottenere il valore numerico dell'anno (gestisce sia numeri che oggetti)
   */
  getAnnoValue(anno: any): number {
    if (typeof anno === 'number') {
      return anno;
    }
    return anno?.anno || anno;
  }

  /**
   * Metodo helper per ottenere il colore dell'anno (gestisce sia numeri che oggetti)
   */
  getAnnoColore(anno: any): string {
    const annoValue = this.getAnnoValue(anno);
    return this.getColoreAnno(annoValue);
  }

  /**
   * Riapplica il filtro di testo globale dopo il caricamento dei dati
   * Usa un approccio con retry per assicurarsi che la tabella sia renderizzata
   */
  riapplicaFiltroTestoGlobale(): void {
    if (!this.filtroTestoGlobale || this.filtroTestoGlobale.length === 0) {
      return;
    }

    // Funzione helper per provare ad applicare il filtro
    const applicaFiltro = (tentativo: number = 0) => {
      const maxTentativi = 20; // Aumentato il numero di tentativi

      // Verifica più accurata: la tabella deve esistere, avere dati e essere renderizzata
      if (
        this.dt &&
        this.richiesteCaricate &&
        this.richieste &&
        this.richieste.length > 0 &&
        typeof this.dt.filterGlobal === 'function'
      ) {
        try {
          // La tabella è disponibile e renderizzata
          this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          console.log(
            `[RICHIESTE] Filtro di testo globale riapplicato: "${this.filtroTestoGlobale}"`,
          );
        } catch (error) {
          console.warn(
            "[RICHIESTE] Errore nell'applicazione del filtro:",
            error,
          );
          // Riprova se c'è un errore
          if (tentativo < maxTentativi) {
            setTimeout(() => {
              applicaFiltro(tentativo + 1);
            }, 100);
          }
        }
      } else if (tentativo < maxTentativi) {
        // La tabella non è ancora disponibile, riprova dopo un breve delay
        setTimeout(() => {
          // Forza il change detection prima di riprovare
          this.cdr.detectChanges();
          applicaFiltro(tentativo + 1);
        }, 100);
      } else {
        console.warn(
          '[RICHIESTE] Impossibile riapplicare il filtro di testo globale: tabella non disponibile dopo',
          maxTentativi,
          'tentativi',
        );
      }
    };

    // Inizia il tentativo di applicazione del filtro
    // Usa un doppio requestAnimationFrame per assicurarsi che il DOM sia completamente aggiornato
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        applicaFiltro();
      });
    });
  }

  dichiaraPronta(richiesta: Richiesta) {
    //this.logger.info(`[RICHIESTE] Dichiara pronta richiesta ${richiesta.id}`);
    this.richiestaSelezionata = richiesta;
    this.mostraDichiarazionePronta = true;
  }

  onDichiarazionePronta() {
    this.messageService.add({
      severity: 'success',
      summary: 'Preparazione conclusa',
      detail: 'La preparazione della richiesta è stata conclusa con successo',
      life: 3000,
    });
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
  }

  getTotaleImportoRichiesto(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoRichiesto || 0),
      0,
    );
  }

  getTotaleImportoContributo(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoContributo || 0),
      0,
    );
  }

  getTotaleImportoRimodulato(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoRimodulato || 0),
      0,
    );
  }

  getTotaleImportoFinanziato(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoFinanziato || 0),
      0,
    );
  }

  getTotaleImportoRendicontato(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoRendicontato || 0),
      0,
    );
  }

  getTotaleImportoLiquidato(): number {
    const richieste = this.dt?.filteredValue || this.richieste;
    return richieste.reduce(
      (totale, richiesta) => totale + (richiesta.importoLiquidato || 0),
      0,
    );
  }

  onFinanziamentoConfermato() {
    //this.logger.info('[RICHIESTE] Finanziamento confermato');
    this.caricaRichieste(this.statoFiltro, this.annoCorrente, this.enteId);
    if (this.isEnteEsecutore || this.isAdminOrUmvs) {
      this.caricaStoricoRichieste();
    }
  }

  confermaFinanziamento(richiesta: Richiesta) {
    this.richiestaSelezionata = richiesta;
    this.mostraConfermaFinanziamento = true;
  }

  /**
   * Metodo helper per ottenere il colore dell'anno per il dropdown
   */
  getColoreAnno(anno: number): string {
    return this.stiliService.getColoreAnnoRichiesta({ anno: anno } as any);
  }

  assegnaMassivamenteDetermine() {
    this.logger.info('[RICHIESTE] Assegna determine in blocco');
    this.mostraAssegnaMassivamenteDetermine = true;
  }
  assegnaMassivamenteDetermineDaUnaRichiesta(richiesta: Richiesta) {
    this.logger.info(
      '[RICHIESTE] Assegna determine in blocco da una richiesta',
    );
    this.richiestaSelezionata = richiesta;
    this.mostraAssegnaMassivamenteDetermine = true;
  }

  onDetermineAssegnate() {
    this.logger.info('[RICHIESTE] Determine assegnate con successo');
    this.mostraAssegnaMassivamenteDetermine = false;
    this.caricaRichieste(
      this.statoFiltro,
      this.annoCorrente,
      this.isEnteEsecutore ? this.enteId : null,
    );
  }

  /**
   * Gestisce il cambio di tab
   */
  onTabChange(event: any): void {
    this.tabAttivaIndex = event.index;
  }

  /**
   * Carica la lista degli enti esecutori per il filtro dello storico
   */
  caricaEntiEsecutori(): void {
    this.entiEsecutoriService.get().subscribe({
      next: (enti) => {
        this.entiEsecutori = enti.sort((a, b) =>
          a.label.localeCompare(b.label),
        );
        // Inizializza il dropdown con "Tutti gli enti" se non è già impostato
        if (!this.enteStoricoSelezionatoPerDropdown) {
          this.enteStoricoSelezionatoPerDropdown = this.TUTTI_GLI_ENTI;
        }
      },
      error: (error) => {
        this.logger.error(
          '[RICHIESTE] Errore nel caricamento degli enti esecutori:',
          error,
        );
      },
    });
  }

  /**
   * Gestisce il cambio del filtro ente nello storico
   */
  onEnteStoricoChange(event: any): void {
    const enteSelezionato = event.value;
    // Aggiorna la versione per il dropdown
    this.enteStoricoSelezionatoPerDropdown = enteSelezionato;

    // Se è l'opzione "Tutti gli enti", imposta a null per la logica di caricamento
    if (enteSelezionato && enteSelezionato.id === -1) {
      this.enteStoricoSelezionato = null;
    } else {
      this.enteStoricoSelezionato = enteSelezionato;
    }
    this.caricaStoricoRichieste();
  }

  /**
   * Carica tutte le richieste storiche per il grafico
   * Per ENTE_ESECUTORE: carica solo le richieste del proprio ente
   * Per UMVS/ADMIN/SUPERADMIN: carica tutte le richieste di tutti gli enti o filtrate per ente selezionato
   */
  caricaStoricoRichieste(): void {
    this.storicoCaricato = false;

    if (this.isEnteEsecutore && this.enteId) {
      // Per ente esecutore: carica solo le richieste del proprio ente
      this.richiesteService.getRichiesteByEnte(this.enteId).subscribe({
        next: (richieste) => {
          this.storicoRichieste = richieste;
          this.aggiornaGrafico();
          this.storicoCaricato = true;
        },
        error: (error) => {
          this.logger.error(
            '[RICHIESTE] Errore nel caricamento dello storico:',
            error,
          );
          this.storicoCaricato = true;
        },
      });
    } else if (this.isAdminOrUmvs) {
      // Per UMVS/ADMIN/SUPERADMIN: carica tutte le richieste o filtrate per ente selezionato
      const enteIdFiltro = this.enteStoricoSelezionato
        ? this.enteStoricoSelezionato.id.toString()
        : null;

      if (enteIdFiltro) {
        // Carica solo le richieste dell'ente selezionato
        this.richiesteService.getRichiesteByEnte(enteIdFiltro).subscribe({
          next: (richieste) => {
            this.storicoRichieste = richieste;
            this.aggiornaGrafico();
            this.storicoCaricato = true;
          },
          error: (error) => {
            this.logger.error(
              '[RICHIESTE] Errore nel caricamento dello storico:',
              error,
            );
            this.storicoCaricato = true;
          },
        });
      } else {
        // Carica tutte le richieste senza filtro ente
        this.richiesteService.getRichieste().subscribe({
          next: (richieste) => {
            this.storicoRichieste = richieste;
            this.aggiornaGrafico();
            this.storicoCaricato = true;
          },
          error: (error) => {
            this.logger.error(
              '[RICHIESTE] Errore nel caricamento dello storico:',
              error,
            );
            this.storicoCaricato = true;
          },
        });
      }
    } else {
      this.storicoCaricato = true;
    }
  }

  /**
   * Aggrega i dati per anno e aggiorna il grafico
   */
  aggiornaGrafico(): void {
    if (!this.storicoRichieste || this.storicoRichieste.length === 0) {
      this.chartData = {
        labels: [],
        datasets: [],
      };
      return;
    }

    // Raggruppa le richieste per anno
    const datiPerAnno: {
      [anno: number]: {
        importoRichiesto: number;
        importoContributo: number;
        importoRimodulato: number;
        importoFinanziato: number;
        importoRendicontato: number;
      };
    } = {};

    this.storicoRichieste.forEach((richiesta) => {
      const anno = richiesta.anno;
      if (!datiPerAnno[anno]) {
        datiPerAnno[anno] = {
          importoRichiesto: 0,
          importoContributo: 0,
          importoRimodulato: 0,
          importoFinanziato: 0,
          importoRendicontato: 0,
        };
      }

      datiPerAnno[anno].importoRichiesto += richiesta.importoRichiesto || 0;
      datiPerAnno[anno].importoContributo += richiesta.importoContributo || 0;
      datiPerAnno[anno].importoRimodulato += richiesta.importoRimodulato || 0;
      datiPerAnno[anno].importoFinanziato += richiesta.importoFinanziato || 0;
      datiPerAnno[anno].importoRendicontato +=
        richiesta.importoRendicontato || 0;
    });

    // Ordina gli anni in ordine crescente
    const anni = Object.keys(datiPerAnno)
      .map(Number)
      .sort((a, b) => a - b);

    // Prepara i dati per il grafico
    const importiRichiesti: number[] = [];
    const importiContributo: number[] = [];
    const importiRimodulati: number[] = [];
    const importiFinanziati: number[] = [];
    const importiRendicontati: number[] = [];

    anni.forEach((anno) => {
      importiRichiesti.push(datiPerAnno[anno].importoRichiesto);
      importiContributo.push(datiPerAnno[anno].importoContributo);
      importiRimodulati.push(datiPerAnno[anno].importoRimodulato);
      importiFinanziati.push(datiPerAnno[anno].importoFinanziato);
      importiRendicontati.push(datiPerAnno[anno].importoRendicontato);
    });

    // Determina il prefisso per le label in base al tipo di utente e al filtro ente
    let labelPrefix = 'Importo ';
    if (this.isAdminOrUmvs) {
      // Quando si seleziona un ente specifico, mostra solo "Importo" senza il nome dell'ente
      // Quando si seleziona "Tutti gli enti", mostra "Importo TOTALE"
      if (!this.enteStoricoSelezionato) {
        labelPrefix = 'Importo TOTALE ';
      }
      // Se enteStoricoSelezionato è impostato, labelPrefix rimane 'Importo ' (senza prefisso aggiuntivo)
    }

    this.chartData = {
      labels: anni.map((anno) => anno.toString()),
      datasets: [
        {
          label: labelPrefix + 'Richiesto',
          data: importiRichiesti,
          backgroundColor: '#FF6B35',
          borderColor: '#FF6B35',
          borderWidth: 2,
          borderRadius: 4,
          borderSkipped: false,
        },
        {
          label: labelPrefix + 'Finanziato',
          data: importiFinanziati,
          backgroundColor: '#06A77D',
          borderColor: '#06A77D',
          borderWidth: 2,
          borderRadius: 4,
          borderSkipped: false,
        },
        {
          label: labelPrefix + 'Rendicontato',
          data: importiRendicontati,
          backgroundColor: '#7B2CBF',
          borderColor: '#7B2CBF',
          borderWidth: 2,
          borderRadius: 4,
          borderSkipped: false,
        },
      ],
    };

    // Configurazione del grafico a barre raggruppate
    this.chartOptions = {
      responsive: true,
      maintainAspectRatio: true,
      aspectRatio: 2.5,
      layout: {
        padding: {
          top: 10,
          right: 15,
          bottom: 10,
          left: 10,
        },
      },
      plugins: {
        legend: {
          position: 'top',
          align: 'center',
          labels: {
            usePointStyle: false,
            padding: 20,
            font: {
              size: 13,
              weight: '600',
            },
            boxWidth: 16,
            boxHeight: 12,
            color: '#3a6e75',
          },
        },
        tooltip: {
          mode: 'index',
          intersect: false,
          backgroundColor: 'rgba(0, 0, 0, 0.85)',
          padding: 12,
          titleFont: {
            size: 14,
            weight: 'bold',
          },
          bodyFont: {
            size: 13,
          },
          borderColor: 'rgba(255, 255, 255, 0.1)',
          borderWidth: 1,
          displayColors: true,
          callbacks: {
            title: (tooltipItems: any) => {
              return `Anno ${tooltipItems[0].label}`;
            },
            label: (context: any) => {
              const label = context.dataset.label || '';
              const value = context.parsed.y;
              const formattedValue = value.toLocaleString('it-IT', {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              });
              return `  ${label}: ${formattedValue}`;
            },
            labelColor: (context: any) => {
              return {
                borderColor: context.dataset.borderColor,
                backgroundColor: context.dataset.backgroundColor,
                borderWidth: 2,
                borderRadius: 2,
              };
            },
          },
        },
      },
      scales: {
        x: {
          stacked: false,
          display: true,
          title: {
            display: true,
            text: 'Anno',
            font: {
              size: 14,
              weight: 'bold',
              family: "'Poppins', sans-serif",
            },
            color: '#3a6e75',
            padding: { top: 10, bottom: 5 },
          },
          grid: {
            display: false,
            drawBorder: true,
            borderColor: '#e2e8f0',
          },
          ticks: {
            font: {
              size: 12,
              weight: '600',
            },
            color: '#64748b',
            padding: 8,
            crossAlign: 'center',
            align: 'center',
          },
        },
        y: {
          stacked: false,
          display: true,
          title: {
            display: true,
            text: 'Importo (€)',
            font: {
              size: 14,
              weight: 'bold',
              family: "'Poppins', sans-serif",
            },
            color: '#3a6e75',
            padding: { top: 5, bottom: 10 },
          },
          grid: {
            display: true,
            color: 'rgba(0, 0, 0, 0.05)',
            drawBorder: true,
            borderColor: '#e2e8f0',
          },
          ticks: {
            font: {
              size: 11,
              weight: '500',
            },
            color: '#64748b',
            padding: 8,
            crossAlign: 'center',
            align: 'center',
            callback: (value: any) => {
              if (value >= 1000000) {
                return (value / 1000000).toFixed(1) + 'M';
              } else if (value >= 1000) {
                return (value / 1000).toFixed(0) + 'k';
              }
              return value.toLocaleString('it-IT', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0,
              });
            },
          },
          beginAtZero: true,
        },
      },
      interaction: {
        mode: 'index',
        axis: 'x',
        intersect: false,
      },
    };
  }
}
